<template>
  <div role="group" :aria-label="i18n.t('buttons.share_on')" class="btn-group d-flex share-box">
    <label class="btn d-none d-md-flex justify-content-center align-items-center">
      {{ i18n.t('buttons.share_on') }}
    </label>

    <component :is="shareButtonComponentForChannel(channel)" v-for="channel of channels" :key="channel.kind"
               :channel="channel" :sharing-options="sharingOptionsForChannel(channel)"
               :show-button-labels="showButtonLabels" />

    <web-share-api-button :label="webShareApiButtonLabel" :sharing-options="sharing.web_share_api"
                          :show-label="showButtonLabels" />
  </div>
</template>

<script>
import BlueskyButton from './share-box/bluesky-button'
import EmailButton from './share-box/email-button'
import FacebookButton from './share-box/facebook-button'
import MessengerButton from './share-box/messenger-button'
import SharingOptionsMixin from './sharing-options-mixin'
import TwitterButton from './share-box/twitter-button'
import WebShareApiButton from './share-box/web-share-api-button'
import WhatsappButton from './share-box/whatsapp-button'

export default {
  components: {
    BlueskyButton, EmailButton, FacebookButton, MessengerButton, TwitterButton, WebShareApiButton, WhatsappButton
  },

  mixins: [SharingOptionsMixin],

  computed: {
    channels() {
      return this.sharing.channels
    },

    showButtonLabels() {
      const desktopVisibleChannels = this.channels.filter((c) => !c.mobileOnly)

      // Don't display the button labels on large screens if we're showing more than 2 buttons,
      // so they fit in one line without breaking into two lines
      return desktopVisibleChannels.length < 2
    }
  }
}
</script>
